import { useContext, useEffect } from 'react'
import { GlobalContext } from '../GlobalContext'
import { useVideo} from '../context/video/VideoContext';
import PhotoPreview from './PhotoPreview';
import RedAlert from '../ui-elements/RedAlert';
import { useOrientation } from '../context/orientation/OrientationContext';



type Props = {
  questionId?: string
  checklistId?: string
  answerPhoto: any
  setAnswerPhoto: any
  defaultValue: null | string | string[]
  setAnswerNote: React.Dispatch<React.SetStateAction<any>>
  answerNote: string | null
  jpegString: string | null
  setJpegString: React.Dispatch<React.SetStateAction<any>>
  setFooterButtons: React.Dispatch<React.SetStateAction<any>>
  isAnswerPending: boolean
  thisQuestion: ObjectStringKeyAnyValue
}

function QuestionPhoto({
 
  questionId,
  jpegString,
  setFooterButtons,
  thisQuestion
}: Props) {

  const { setQRCodesSearchOptions, cameraState } = useVideo()
  const {orientation, sensorOrientation, windowOrientation} = useOrientation()
  // const [jpegString, setJpegString] = useState<string | undefined>(undefined)
  const {
    tableData,
    setIsVideoMode,
    setIsVideoPlaying
  } = useContext(GlobalContext)



  useEffect(() => {
    // console.log("✅ Turning video on")
    setIsVideoMode(true)
    setIsVideoPlaying(true)
    setQRCodesSearchOptions({ 'enabled': true })
    return () => {
      // code to run when the user navigates away from the pagev
      // console.log("⛔️ leaving page")
      setIsVideoMode(false)
      setIsVideoPlaying(false)
    }
  }, [questionId])



  

  useEffect(() => {
    if (jpegString){
      setFooterButtons(['retakePhoto', 'saveWithNote', 'save'])
    } else {
        if (thisQuestion && thisQuestion.isAnswerRequired === false){
          setFooterButtons(['skip', 'back', 'takePhoto'])
        } else {
          setFooterButtons(['back', 'takePhoto'])
        }
    }
  }, [jpegString])



  return <>
  <div className={` ${jpegString ? ' pt-8' : ' pt-20 '} max-w-3xl w-full pb-8 px-3 flex flex-col gap-2 items-center justify-center`}>

    {/*<div style={{background:'white', padding: '3px'}}>resolved: {orientation} - sensor: {sensorOrientation} - window: {windowOrientation}</div>*/}
  
    {cameraState === 'PERMISSION_DENIED' && <RedAlert>
      Camera access has been blocked by a user. Please check your device settings to allow camera access for this app.
    </RedAlert>
    }
    {cameraState === 'ERROR' && <RedAlert>
      An unexpected error occurred while accessing the camera. Please try again or check your device settings.
    </RedAlert>
    }
    {cameraState === 'NO_CAMERA_FOUND' && <RedAlert>
      No camera found. Please ensure your device has a camera and it is not being used by another application.
    </RedAlert>
    }

    {cameraState === 'CAMERA_UNREADABLE' && <RedAlert>
      The camera is currently unreadable. Please ensure no other applications are using the camera and try again.
    </RedAlert>
    }
   
    {jpegString && <PhotoPreview
      jpegString={jpegString}
    />}

  </div>
  </>
}
export default QuestionPhoto